import React, { useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ProgramDropdown, TimesheetTaskDropdown } from "CommonDropdowns";
import moment from 'moment-timezone';

const Filter = ({
    onFilter,
    extraFiltersState,
    setExtraFiltersState,
    hidePeriodPicker = false,
    hideProgramDropdown = false,
    showTaskFilter = false,
    showTaskMultiSelect = false,
    taskOptions = [],
}) => {
    const [programValue, setProgramValue] = useState(null);
    const [taskValue, setTaskValue] = useState(null);



    const handleSearch = () => {
        onFilter();
    };

    const handleInputChange = (name, value) => {
        setExtraFiltersState({
            ...extraFiltersState,
            values: {
                ...extraFiltersState.values,
                [name]: value,
            },
        });
    };

    const handleDateChange = (date) => {  
        if(!date){
            setExtraFiltersState({
                ...extraFiltersState,
                values: {
                    ...extraFiltersState.values,
                    year: '',
                    month: '',
                    program: [],
                    task_ids: [],
                    selectedDate: null,
                    formatDate: ''
                },
            });
            setProgramValue(null);
            setTaskValue(null);
        }else{
            let formatDate = moment(date).format('YYYY-MM');
            setExtraFiltersState({
                ...extraFiltersState,
                values: {
                    ...extraFiltersState.values,
                    year: date.getFullYear(),
                    month: date.getMonth() + 1,
                    'formatDate': formatDate,
                    selectedDate: date
                },
            });
        }
        
    };

    const handleProgramChange = (selected) => {
        setProgramValue(selected);
        const programIds = selected ? selected.map(p => p.value) : [];
        handleInputChange("program", programIds);
    };

    const handleTaskChange = (event) => {
        handleInputChange("task", event.target.value);
    };

    const handleTaskMultiChange = (selected) => {
        setTaskValue(selected);
        const taskIds = selected ? selected.map((t) => t.value).filter((val) => val !== 'all') : [];
        handleInputChange("task_ids", taskIds);
    };

    const selectedPrograms = extraFiltersState.values.program || [];
    const taskProgramId = selectedPrograms.length === 1 ? selectedPrograms[0] : null;

    const periodColSize = showTaskFilter || showTaskMultiSelect ? 3 : 5;
    const programColSize = showTaskFilter || showTaskMultiSelect ? 3 : 5;
    const searchColSize = showTaskFilter || showTaskMultiSelect ? 3 : 2;

    return (
        <div className="filters-flex">
            <Form>
                <Row className="align-items-end g-3">
                    {!hidePeriodPicker && (
                        <Col md={periodColSize} sm={12}>
                            <Form.Group className="mb-3">
                                <Form.Label className="label-input">Period</Form.Label>
                                <DatePicker
                                    selected={extraFiltersState.values.selectedDate}
                                    onChange={handleDateChange}
                                    dateFormat="yyyy-MM"
                                    showMonthYearPicker
                                    className="input-field form-control"
                                />
                            </Form.Group>
                        </Col>
                    )}
                    {!hideProgramDropdown && (
                        <Col md={programColSize} sm={12}>
                            <Form.Group className="mb-3">
                                <ProgramDropdown
                                    programValue={programValue}
                                    setProgramValue={setProgramValue}
                                    isMulti
                                    selectedId={extraFiltersState.values.program}
                                    programOnChange={handleProgramChange}
                                />
                            </Form.Group>
                        </Col>
                    )}
                    {showTaskMultiSelect && (
                        <Col md={3} sm={12}>
                            <TimesheetTaskDropdown
                                taskValue={taskValue}
                                setTaskValue={setTaskValue}
                                isMulti
                                selectedId={extraFiltersState.values.task_ids || []}
                                taskOnChange={handleTaskMultiChange}
                                programId={taskProgramId}
                                placeholder="Select Task"
                            />
                        </Col>
                    )}
                    {showTaskFilter && (
                        <Col md={3} sm={12}>
                            <Form.Group className="mb-3">
                                <Form.Label className="label-input">Task</Form.Label>
                                <Form.Select
                                    className="input-field"
                                    value={extraFiltersState.values.task || ""}
                                    onChange={handleTaskChange}
                                >
                                    <option value="">All Tasks</option>
                                    {taskOptions.map((task) => (
                                        <option key={task} value={task}>{task}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    )}
                    <Col md={searchColSize} sm={12} className="d-flex gap-2 mt-3 mt-md-0">
                        <button
                            type="button"
                            onClick={handleSearch}
                            className="add-new-btn w-100 mb-3"
                        >
                            <img src="/assets/images/search-white.svg" alt="" className="me-2" /> Search
                        </button>
                    </Col>
                </Row>
            </Form>
        </div>
    );
};

export default Filter;
